import { Fragment } from 'react';
import Link from 'next/link';
import SpacingBlock from '@features/cms/components/collections/SpacingBlock/SpacingBlock';
import theme from '@styles/theme';
import { splitTextByLineBreaks } from '@utils/splitTextByLineBreaks';
import styles from './CategoryTilesBlock.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
export interface CategoryTile {
  id: string;
  label: string;
  href: string;
  image?: string;
}
export interface CategoryTilesBlockData {
  tiles?: CategoryTile[];
  marginTop?: number;
  marginBottom?: number;
  background?: string;
  code?: string;
}
export interface CategoryTilesBlockProps {
  data: CategoryTilesBlockData;
}
const CategoryTilesBlock = ({
  data
}: CategoryTilesBlockProps) => {
  const {
    tiles,
    marginTop,
    marginBottom,
    background,
    code
  } = data;
  const spacingBg = background || theme.rawColors.neutralWhite;
  return <>
      {Number(marginTop) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginTop)),
      code: 'mt'
    }} />}
      <section sx={{
      ...styles.section,
      ...(background && {
        backgroundColor: background
      })
    }} data-testid={code}>
        <div sx={styles.container} data-testid="CategoryTilesBlock-container">
          {/* Tiles grid */}
          {tiles && tiles.length > 0 && <div sx={styles.grid} data-testid="CategoryTilesBlock-grid">
              {tiles.map(tile => <div key={tile.id} sx={styles.tileWrapper} data-testid="CategoryTilesBlock-tileWrapper">
                  <Link href={tile.href} sx={styles.tile}>
                    {tile.image && <div sx={styles.tileImage} data-testid="CategoryTilesBlock-tileImage">
                        <ResponsiveImage image={tile.image} alt={splitTextByLineBreaks(tile.label).join(' ')} objectFit="contain" />
                      </div>}
                    <span sx={styles.tileLabel}>
                      {splitTextByLineBreaks(tile.label).map((line, index) => <Fragment key={index}>
                          {index > 0 ? <br /> : null}
                          {line}
                        </Fragment>)}
                    </span>
                  </Link>
                </div>)}
            </div>}
        </div>
      </section>
      {Number(marginBottom) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginBottom)),
      code: 'mb'
    }} />}
    </>;
};
export default CategoryTilesBlock;